import * as types from './actionTypes';

export function saveTemplateList(data) {
    return {
        type: types.SAVE_TEMPLATE_LIST,
        data,
    };
}

export function saveTemplateItem(data) {
    return {
        type: types.SAVE_TEMPLATE_ITEM,
        data,
    };
}


// WEBPACK FOOTER //
// ./src/actions/templateActions.js